import { cn } from '@/lib/utils';

/** Small "new" marker. Decorative — every user of it also carries text
 *  (an sr-only hint or an accessible-name variant) for assistive tech. */
export function UnreadDot({ className }: { className?: string }) {
    return (
        <span
            aria-hidden
            data-slot="unread-dot"
            className={cn('pointer-events-none block size-2 rounded-full bg-primary', className)}
        />
    );
}
